import React, { useEffect } from "react";
import { Datagrid, FunctionField, ListContextProvider, TextField, useListContext } from "react-admin";
import { useHistory } from "react-router-dom";
import { GetServiceableStatus } from "../../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus } from "../../../../../Enums/UnserviceableStatus";
import CustomLinearProgress from "../../../../../Components/Progress/LinearProgress";
import RequestStatusField from "../../../../../Components/ReferenceFields/RequestStatus/RequestStatusField";
import Actions from "./Actions";
import { formatDate } from "../../../../../Helper/MomentHelper";

export const DataGrid = props => {
  const listContext = useListContext();
  const history = useHistory();
  const { record, activeTab, setActiveTab, createId, reloadTabs, ...rest } = props;
  const { ids, filterValues, setFilters, displayedFilters, loading, data } = listContext;
  useEffect(() => {
    setFilters({ tabValue__eq: activeTab }, displayedFilters);
  }, [activeTab]);

  return (
    <ListContextProvider
      {...rest}
      value={{
        ...listContext,
        ids: ids,
      }}
    >
      <CustomLinearProgress loading={loading} periodTime={500} />
      <Datagrid optimized {...props} hasBulkActions={false}>
        <Actions label="Actions" props={props} />
        <TextField source="request.refNo" label="Ref No" />
        <TextField source="serviceable.awb" label="Svc Awb" />
        <TextField source="request.requirementCategoryText" label={"Requirement Category"} />
        <TextField source="request.pn" label={"Part No"} />
        <TextField source="request.pnDescription" label={"Part No Desc"} />
        <TextField source="serviceable.pn" label="Svc Pn" />
        <TextField source="serviceable.sn" label="Svc Sn" />
        <TextField source="request.airportCode" label={"Airport"} />
        <TextField source="request.customerPo" label="Customer Po" />
        <FunctionField
          label="Requested Date"
          render={(record: any) => {
            return formatDate(record.request.createdDate);
          }}
        />
        <FunctionField
          label="Requested Delivery Date"
          render={(record: any) => {
            return record.request.requestedDeliveryDate === null
              ? "Not Arrived Yet"
              : formatDate(record.request.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                ? "Exclude"
                : formatDate(record.request.requestedDeliveryDate, false);
          }}
        />
        <FunctionField
          label="Status"
          render={(record: any) => (
            <RequestStatusField record={record.request} reference="pbhrequeststatusinfo/reference" />
          )}
        />
        <FunctionField
          label="Serviceable Status"
          render={(record: any) =>
            GetServiceableStatus?.find?.(x => x.Value == record?.serviceable?.status)?.Description ?? ""
          }
        />
        <FunctionField
          label="Core Unit Status"
          render={(record: any) =>
            GetUnserviceableStatus?.find?.(x => x.Value == record?.unserviceable?.status)?.Description ?? ""
          }
        />
      </Datagrid>
    </ListContextProvider>
  );
};

export default DataGrid;
